// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "32d62d8e56d4f50ef4e9e3fd4f54391a" + ".js";
};